<style lang="less">
.img-upload-wrap {
  position: relative;
  width: 100%;
  height: 100%;
  background: #f3f3f9;
  border-radius: 10px;
  // overflow: hidden;
  .img-preview {
    position: relative;
    width: 100%;
    height: 100%;
    border-radius: 5px;
    overflow: hidden;
    border-radius: 10px;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .img-upload-btn {
    width: 100%;
    height: 100%;
    position: absolute;
    left: 0;
    top: 0;
    z-index: 2;
    .mask {
      position: absolute;
      width: 100%;
      height: 100%;
      left: 0;
      top: 0;
      background: #000;
      opacity: 0;
      border-radius: 10px;
    }
    &:hover {
      .mask {
        opacity: 0.3;
      }
      .btn {
        .btn-icon {
          display: flex;
          flex-direction: column;
          align-items: center;
        }
        .icon-wrap {
          display: block;
          // background: rgba(0, 0, 0, 0.6);
        }
      }
      .cover-list-select-wrap {
        display: block;
      }
    }
    .btn {
      width: 100%;
      height: 100%;
      display: block;
      text-align: center;
      cursor: pointer;
      position: relative;
      z-index: 2;
      .btn-icon {
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        display: flex;
        flex-direction: column;
        align-items: center;
        .icon-wrap {
          display: block;
          width: 46px;
          height: 46px;
          background: rgba(0, 0, 0, 0.3);
          border-radius: 50%;
          display: none;
          position: relative;
          &.show {
            display: block;
          }
          .icon {
            position: absolute;
            left: 50%;
            top: 50%;
            transform: translate(-50%, -50%);
            font-size: 20px;
            color: #fff;
          }
        }
        .tips {
          display: block;
          position: relative;
          font-size: 14px;
          line-height: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #93939d;
          margin-top: 16px;
          width: 80px;
        }
      }
    }
    input {
      position: absolute;
      left: 0;
      top: 0;
      z-index: 1;
      clip: rect(0px, 0px, 0px, 0px);
    }

    .cover-list-select-wrap {
      display: none;
      position: absolute;
      top: 100%;
      left: 0;
      padding-top: 5px;
      width: auto;
      ul {
        display: flex;
        padding: 20px;
        background: #fff;
        border-radius: 10px;
        box-shadow: 0px 3px 20px 0px rgba(58, 59, 69, 0.05);
        user-select: none;
        li {
          display: inline-block;
          width: 109px;
          height: 62px;
          background: #e9ecf3;
          border-radius: 10px;
          margin-left: 20px;
          overflow: hidden;
          &:first-child {
            margin-left: 0;
          }
          &.tip {
            line-height: 20px;
            background: none;
            min-width: 220px;
            font-size: 12px;
            color: #93939d;
            display: flex;
            align-items: center;
          }
          &.upload-item {
            text-align: center;
            color: #93939d;
            line-height: 62px;
            position: relative;
            label {
              display: block;
              width: 100%;
              height: 100%;
              position: absolute;
              left: 0;
              top: 0;
              cursor: pointer;
            }
            &:hover {
              background: #f0f7ff;
            }
          }
          img {
            width: 100%;
            height: 100%;
            cursor: pointer;
            object-fit: cover;
          }
        }
      }
    }
  }
}
.img-cropper-box {
  background: #fff;
  .cut-wrap {
    margin: 0 auto;
    .cropper-crop-box {
      .cropper-view-box {
        // outline: none;
        outline: 1px solid #3c3cff;
      }
    }
    .crop-info {
      display: none;
    }
  }
  .t-btns-wrap {
    padding: 50px 0 40px 0;
    text-align: center;
  }
}
</style>
<template>
  <div class="img-upload-wrap" v-loading="uploading">
    <div class="img-preview" v-if="src">
      <img :src="src" />
    </div>
    <div class="img-upload-btn" v-if="!disabled">
      <div class="mask"></div>
      <label class="btn" :for="file">
        <span class="btn-icon">
          <span class="icon-wrap" :class="{ show: src == '' }">
            <svg class="icon" aria-hidden="true">
              <use xlink:href="#icon-a-tianjia2x"></use>
            </svg>
          </span>
          <span v-if="tips && src == ''" class="tips">{{ tips }}</span>
        </span>
      </label>

      <!-- 直接传 -->
      <template v-if="!crop || (crop && !cropList)">
        <input
          type="file"
          :id="file"
          style="position: absolute; clip: rect(0 0 0 0)"
          accept="image/png, image/jpeg,image/jpg, image/*"
          :ref="file"
          @change="chooseImg($event)"
        />
      </template>

      <!-- 裁剪 -->
      <template v-else>
        <div class="cover-list-select-wrap">
          <ul>
            <template v-if="cropImgList.length == 0">
              <li class="tip">
                视频上传完成后才可以选取视频帧封面<br />您也可以先本地上传封面
              </li>
            </template>
            <template v-else>
              <li
                v-for="(item, index) in cropImgList"
                :key="index"
                @click="initCropperImg(item)"
              >
                <img :src="item" />
              </li>
            </template>
            <li v-show="imgLocal" @click="initCropperImg(imgLocal)">
              <img :src="imgLocal" />
            </li>
            <li class="upload-item">
              <span>本地上传</span>
              <label :for="file"> </label>
              <input
                type="file"
                :id="file"
                :ref="file"
                style="position: absolute; clip: rect(0 0 0 0)"
                accept="image/png, image/jpeg,image/jpg, image/*"
                @change="chooseImg($event, 'local')"
              />
            </li>
          </ul>
        </div>
      </template>
    </div>

    <el-dialog
      :width="cropWidth + 120 + 'px'"
      custom-class="crop-dialog"
      title="图片裁剪"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :visible.sync="cropDialogShow"
      append-to-body
    >
      <div class="img-cropper-box">
        <div
          class="cut-wrap"
          :style="{ width: cropWidth + 'px', height: cropHeight + 'px' }"
          v-loading="uploading"
        >
          <vue-cropper
            :ref="croper"
            :img="option.img"
            :output-size="option.size"
            :output-type="option.outputType"
            :info="true"
            :full="option.full"
            :can-move="option.canMove"
            :can-move-box="option.canMoveBox"
            :fixed-box="option.fixedBox"
            :original="option.original"
            :auto-crop="option.autoCrop"
            :auto-crop-width="cropWidth"
            :auto-crop-height="cropHeight"
            :center-box="option.centerBox"
            :high="option.high"
            mode="cover"
            :max-img-size="option.max"
            :enlarge="cropEnlarge"
          ></vue-cropper>
          <!-- @imgMoving="imgMoveEvent" -->
        </div>
        <div class="t-btns-wrap">
          <el-button
            type="normal"
            class="m-btn normal small"
            @click="resetImg()"
            >重置</el-button
          >
          <el-button
            type="normal"
            class="m-btn normal small"
            @click="cancelCrop()"
            >取消</el-button
          >
          <el-button
            type="primary"
            class="m-btn small"
            @click="highQuality ? doCropHighQuality() : doCrop()"
            :disabled="uploading"
            >确定裁剪</el-button
          >
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import {
  getFileBase64By64Bytes,
  calculateMD5Binary,
  calculateMD5Base64,
  fileUpload,
} from '@/utils/upload';
import { getFileUploadToken } from '@/servies/index.js';

import { VueCropper } from 'vue-cropper';

export default {
  name: 'imgCropUpload',
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    crop: {
      type: Boolean,
      default: false,
    },
    cropList: {
      type: Boolean,
      default: false,
    },
    highQuality: {
      type: Boolean,
      default: true, // 默认启用高画质模式
    },
    cropWidth: {
      type: Number,
      default: 667,
    },
    cropHeight: {
      type: Number,
      default: 375,
    },
    cropEnlarge: {
      type: Number,
      default: 1,
    },
    imgWidth: {
      type: Number,
      // default: 750
      default: 0,
    },
    imgHeight: {
      type: Number,
      // default: 750
      default: 0,
    },
    src: {
      type: String,
      default: '',
    },
    imgs: {
      type: Array,
      default: () => {
        return [];
      },
    },
    tips: {
      type: String,
      default: '',
    },
    ossStsToken: {
      type: String,
      default: '',
    },
    biz: {
      type: String,
      default: '',
    },
    bizKey: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      cropDialogShow: false,
      imageTypes: ['image/jpeg', 'image/png', 'image/webp', 'image/gif'],
      imageUrl: '',
      uploading: false,
      option: {
        img: '',
        size: 1, // 改为更高的画质值或使用无损模式
        full: false, //是否按原比例
        outputType: 'png', // 改为 PNG 无损格式，避免 JPG 压缩
        canMove: true, //原图拖动
        fixedBox: true, //裁剪框是否可固定大小
        original: true, // 改为 true，保持原始分辨率
        canMoveBox: false,
        autoCrop: true,
        // 只有自动截图开启 宽度高度才生效
        centerBox: false, //截图框是否被限制在图片里面
        high: true, // 保持高画质输出
        max: 99999,
        fixedNumber: [16, 9],
      },
      fixed: true,
      uploadConf: {
        region: null,
        accessKeyId: null,
        accessKeySecret: null,
        bucket: null,
        stsToken: null,
      },

      imgLocal: false,
    };
  },
  components: {
    VueCropper,
  },
  computed: {
    file() {
      return 'file' + Math.floor(Math.random() * 1000);
    },
    croper() {
      return 'croper' + Math.floor(Math.random() * 1000);
    },
    cropImgList() {
      return this.imgs;
    },
  },
  watch: {},
  async created() {
    this.imageUrl = this.src;
    this.uploading = false;
  },
  methods: {
    initCropperImg(img) {
      this.option.img = img;
      this.cropDialogShow = true;
    },
    cropperSuccess(data) {
      if (this.showCropper == 'horizon') {
        this.$set(this.formData, 'crossImg', data.url);
      }
      if (this.showCropper == 'verical') {
        this.$set(this.formData, 'verticalImg', data.url);
      }
      this.showCropper = false;
    },
    chooseImg(e, type = '') {
      const _this = this,
        file = e.target.files[0];
      if (file) {
        const i = file.name.lastIndexOf('.'),
          suffix = file.name.substr(i);
        if (!/\.(gif|jpg|jpeg|png|JPG|PNG)$/.test(suffix)) {
          this.$message({
            message: '图片类型必须是jpeg,jpg,png中的一种',
            type: 'warring',
          });
          return false;
        }

        const reader = new FileReader();
        reader.onload = (e) => {
          let data;
          if (typeof e.target.result === 'object') {
            // 把Array Buffer转化为blob 如果是base64不需要
            data = window.URL.createObjectURL(new Blob([e.target.result]));
          } else {
            data = e.target.result;
          }
          // 不裁剪
          if (!this.crop) {
            if (_this.imgWidth || _this.imgHeight) {
              const img = new Image();
              img.src = data;
              img.onload = function () {
                let sizeCheck = true;
                if (_this.imgWidth && img.width != _this.imgWidth)
                  sizeCheck = false;
                if (_this.imgHeight && img.height != _this.imgHeight)
                  sizeCheck = false;
                if (sizeCheck) {
                  _this.uploadHttp(file, suffix);
                } else {
                  _this.$message({
                    message: '图片尺寸不符合要求',
                    type: 'error',
                  });
                }
              };
            } else {
              _this.uploadHttp(file, suffix);
            }
          } else {
            // 裁剪
            this.option.img = data;

            if (type == 'local') this.imgLocal = data;

            // 打开裁剪
            if (this.crop) this.cropDialogShow = true;
          }
        };
        // 转化为base64
        reader.readAsDataURL(file);
        this.$refs[this.file].value = '';
        // 转化为blob
        // reader.readAsArrayBuffer(file)
      }
    },
    imgMoveEvent(data) {
      console.log(data);
    },
    resetImg() {
      this.$refs[this.croper].refresh();
    },
    async uploadHttp(file, suffix = '.jpg') {
      console.log(suffix);
      this.uploading = true;

      const requestFile = file;
      const base64 = await getFileBase64By64Bytes(requestFile);
      const fileExtension = file.type.split('/')[1];
      try {
        const binaryHash = calculateMD5Binary(requestFile);
        getFileUploadToken({
          platType: 3,
          fileHeadBase64: base64,
          fileSize: requestFile.size,
          fileSubfix: fileExtension,
          fileContentMd5: calculateMD5Base64(binaryHash),
        }).then((res) => {
          const { code } = res.data;
          if (code === 200) {
            const token = res.data.data;
            this.showVideoSelectWrap = false;
            this.videoUploading = true;
            this.uploadStatusText = '上传中...';
            this.loading = false;
            fileUpload(
              token,
              requestFile,
              (percent) => {
                console.log(`图片上传进度监听>>>${percent}`);
              },
              (success) => {
                console.log('图片上传成功');
                let data = {
                  idStrImage: token.keyInfo.idstr,
                  url: success.Location,
                };
                this.$emit('success', data);
                this.uploading = false;
                this.cropDialogShow = false;
                this.imgLocal = false;
              },
              (error) => {
                console.log(error);
                console.log('croper upload err ..');
                this.uploading = false;
                this.cropDialogShow = false;
              }
            );
          } else {
            console.log('croper upload err ..');
            this.uploading = false;
            this.cropDialogShow = false;
          }
        });
      } catch (e) {
        console.log('croper upload err ..');
        this.uploading = false;
        this.cropDialogShow = false;
      }
    },
    doCrop() {
      this.uploading = true;
      // 使用 getCropData 获取更高画质的 base64 数据，然后转换为 Blob
      // 或者使用 getCropBlob 的第二个参数指定更高画质
      this.$refs[this.croper].getCropBlob(
        (data) => {
          this.uploadHttp(data);
        },
        'image/png',
        1
      ); // 第三个参数是画质，1 表示最高画质，格式改为 PNG
    },

    // 备用的无损裁剪方法
    doCropHighQuality() {
      this.uploading = true;
      // 使用 getCropData 获取原始画质的 base64
      this.$refs[this.croper].getCropData((data) => {
        // 将 base64 转换为 Blob，保持原始画质
        const byteCharacters = atob(data.split(',')[1]);
        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        const blob = new Blob([byteArray], { type: 'image/png' });
        this.uploadHttp(blob);
      });
    },
    cancelCrop() {
      this.uploading = false;
      this.imgLocal = false;
      this.cropDialogShow = false;
    },
    cancel() {
      this.$emit('cancel');
    },
  },
};
</script>
